<template>
  <div v-if="operation" class="operation-details">
    <BarButton
      iconHead="i-calendar"
      :title="formattedDates"
      iconTail=""
      class="text-size-m"
    />
    <ProductButton
      :title="`${operation.items.length} ${$gettext(
        operation.items.length === 1 ? 'операция' : 'операций'
      )}`"
      class="text-size-m"
    >
      <template #tail>
        <span :class="{ 'text-green': !operation.is_expense }">
          {{
            `${operation.is_expense ? "-" : "+"} ${$currencyFormatter(
              Math.ceil(operation.amount)
            )}`
          }}
        </span>
      </template>
    </ProductButton>
    <RedHistoryItems
      :items="operation.items || []"
      :loading="false"
      class="text-size-m"
    />
  </div>
</template>

<script>
import "@/jsdoc/types/statements";
import { getStatementDateFormat, getFormattedDate } from "@/utils/date";
import RedHistoryItems from "@/components/dashboard/history/RedHistoryItems.vue";
import BarButton from "@/components/shared/button/BarButton.vue";
import ProductButton from "@/components/shared/button/ProductButton.vue";
import { computed } from "vue";

export default {
  props: {
    operation: {
      /**
       * @type {import('vue').PropType<OperDetails>}
       */
      type: Object,
      required: true,
    },
    type: {
      /**
       * @type {import('vue').PropType<OperType>}
       */
      type: String,
      required: true,
    },
    dates: {
      /**
       * @type {import('vue').PropType<Dates>}
       */
      type: Object,
      required: true,
    },
  },
  components: {
    RedHistoryItems,
    BarButton,
    ProductButton,
  },
  setup(props) {
    const formattedDates = computed(() => {
      const fromFormat = getStatementDateFormat(props.dates.from);
      const toFormat = getStatementDateFormat(props.dates.to);

      return `${getFormattedDate(
        props.dates.from,
        fromFormat
      )} - ${getFormattedDate(props.dates.to, toFormat)}`;
    });

    return {
      formattedDates,
    };
  },
};
</script>

<style lang="scss" scoped></style>
